import moment from "moment";

var DateMixin = {
  filters: {
    formatDate(DateVar) {
      return moment(DateVar).fromNow();
    },
    formatDateNormal(DateVar) {
      return moment(DateVar).format("DD.MM.YYYY");
    },
  },
  methods: {
    checkDate(DateVar, Days) {
      if (!Days) console.error("No days amount was given.");
      if (Days > 0) {
        return moment(DateVar).isBefore(moment().add(Days, "d"));
      } else {
        return moment(DateVar).isAfter(moment().add(Days, "d"));
      }
    },
    daysUntil(DateVar) {
      return moment(DateVar).diff(moment(), "days");
    },
    timeUntil(DateVar) {
      return moment().to(moment(DateVar));
    },
    isToday(DateVar) {
      return moment(DateVar).isSame(moment(), "day");
    },
    isPastDate(DateVar, DaysPast) {
      return moment(DateVar).isSame(moment().subtract(DaysPast, "d"), "day");
    },
    isFutureDate(DateVar, DaysPast = 0) {
      return moment(DateVar).isAfter(moment().add(DaysPast, "d"), "day");
    },
    getDate(DateVar) {
      return moment(DateVar).fromNow();
    },
    getTodayNumber() {
      return moment().day();
    },
    getDayNumber(DateVar) {
      return moment(DateVar).weekday();
    },
    getYear() {
      return moment().year();
    },
    momentify(DateVar) {
      return moment(DateVar);
    },
    momentDate() {
      return moment();
    },
    momentFormat(DateVar, FormatString) {
      return moment(DateVar).format(FormatString);
    },
    nowFormat(FormatString) {
      return moment().format(FormatString);
    }
  },
};

export default DateMixin;
